// @ts-ignore
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';

import { initLogger } from '@/services/logger';

import App from './App';

initLogger();

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(<App />);
